import { useMutation } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";
import { TENANT_COMPANY_MAP } from "../../../utils/constants";
import { getTenantId } from "../../../utils/helpers";

const triggerCsvDownload = (csvString, quotationId) => {
    if (!csvString) return;
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `IndentMedicineList-Q${quotationId}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

const DownloadMedicineList = (quotationId) => {
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;

    if (!isEasydose) {
        return useMutation(() => Promise.resolve(null));
    }

    return useMutation(
        () =>
            request({
                url: `/hinai/userorder/downloadIndentMedicineList/${quotationId}`,
                method: "GET",
            }),
        {
            onSuccess: (response) => {
                if (response?.data?.success) {
                    const csvString = response?.data?.data?.medicineList ?? "";
                    triggerCsvDownload(csvString, quotationId);
                    toast.success("Medicine list downloaded");
                } else {
                    toast.error(
                        response?.data?.error || "Failed to download medicine list"
                    );
                }
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.error ||
                    error?.message ||
                    "Failed to download medicine list";
                toast.error(errorMessage);
            },
        }
    );
};

export default DownloadMedicineList;